import store from '@/store';
import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import { composeMixins, mixins } from '../mixins';

const { CreativeTemplateMixin, DeliveryContentMixin } = mixins;

const CombinedMixins = composeMixins([
  CreativeTemplateMixin,
  DeliveryContentMixin,
]);

/**
 * 管理小米渠道的数据
 */
export default class XiaomiDataSourceController extends CombinedMixins(DataSourceController) {
  /**
   * 获取深度优化目标枚举
   * @returns {Promise<Object>}
   */
  async getDeepConvertGoalEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_deep_convert_type : {};
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
